"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var BaseWidgetController_1 = require("../BaseWidgetController");
var loggers_1 = require("../../loggers");
var baseUrl_1 = require("../../baseUrl");
var MemberInvitesController = /** @class */ (function (_super) {
    tslib_1.__extends(MemberInvitesController, _super);
    function MemberInvitesController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.loadMemberInvitesLink = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var memberInvitesLink, response, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        memberInvitesLink = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getInviteLink()];
                    case 2:
                        response = _a.sent();
                        memberInvitesLink = response.data.url;
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.setState({
                            memberInvitesLink: memberInvitesLink,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setApi(_this.getSiteToken());
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    this.setApi(instance);
                    return [2 /*return*/];
                });
            });
        });
        return _this;
    }
    MemberInvitesController.prototype.setApi = function (siteToken) {
        var location = this.getLocation();
        this.api = new social_groups_api_1.MemberInvitesApi(siteToken, baseUrl_1.getClubsApiUrl(location.baseUrl));
    };
    MemberInvitesController.prototype.pageReady = function ($w, wixAPI) {
        return Promise.resolve();
    };
    MemberInvitesController.prototype.getInitialProps = function () {
        return Promise.resolve({
            loadMemberInvitesLink: this.loadMemberInvitesLink,
        });
    };
    return MemberInvitesController;
}(BaseWidgetController_1.BaseWidgetController));
exports.MemberInvitesController = MemberInvitesController;
//# sourceMappingURL=MemberInvitesController.js.map